import React from 'react';
import BlackDot from '../../../../../../../static/blackDot.svg';
import * as styles from './equipmentServices.module.scss';
import { OtTemplateQuery } from '../../../../../../../graphql-types';
import { usePageContext } from '../../../../../../hooks/contexts/usePageContext';
import { FaIcon } from '../faIcon/FaIcon';

interface IEquipmentServicesProps {
  data: NonNullable<NonNullable<OtTemplateQuery['ingenieOt']>['content']>['equipments'];
}

export const EquipmentServices = ({ data }: IEquipmentServicesProps) => {
  const { lang } = usePageContext();
  return (
    <ul className={styles.wrapper}>
      {data?.map((eq) => (
        <li key={eq?.label?.[lang]} className={styles.serviceWrapper}>
          <div>
            <BlackDot />
          </div>
          <div>{eq?.label?.[lang]}</div>
          <div className={styles.icon}>
            {eq?.pictoUrl !== '' && (
              <img src={eq?.pictoUrl ?? ''} alt={eq?.label?.[lang]} loading="lazy" />
            )}
          </div>
        </li>
      ))}
    </ul>
  );
};
